import { dateFormatter } from "@/components/DateFormat/DateFormat";
import styles from "./AppliedFilter.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import type { ClearFilterFn, ClearFilterKey } from "./FilterInterface";

interface Props {
    title: string;
    fromValue: string;
    toValue: string;
    filterKey: ClearFilterKey;
    clearFilter: ClearFilterFn;
    format: string;
}

const closeIcon = <CloseIcon fontSize="small" />;

const DateFilterChip = ({
    title,
    fromValue,
    toValue,
    filterKey,
    clearFilter,
    format,
}: Props) => {
    if (!fromValue || !toValue) return null;

    return (
        <div className="flex items-center gap-4 ml-4">
            <div className={styles.filtersModeHead}>
                <span>{`By ${title ? title : "Date"}`}</span>

                <button
                    type="button"
                    className={styles.customClose}
                    onClick={() => clearFilter(filterKey)}
                >
                    {closeIcon}
                </button>
            </div>

            <div className={styles.filtersMode}>
                <div className="inline-block">
                    From {dateFormatter(fromValue, format)}{" "}
                    To {dateFormatter(toValue, format)}
                </div>

                <button
                    type="button"
                    className={styles.customClose}
                    onClick={() => clearFilter(filterKey)}
                >
                    {closeIcon}
                </button>
            </div>
        </div>
    );
};

export default DateFilterChip;